import script from "./TopTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TopTitle.vue?vue&type=script&setup=true&lang=js"

import "./TopTitle.vue?vue&type=style&index=0&id=966ca982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-966ca982"]])

export default __exports__